// extracted by mini-css-extract-plugin
module.exports = {"button":"StartButton_button__u5Wrj"};